export interface WikimediaFlagAsset {
  code: string;
  state: string;
  imagePath: string;
  imageUrl: string;
  sourcePageUrl: string;
}

export const WIKIMEDIA_FLAG_ASSETS: Record<string, WikimediaFlagAsset> = {
  AK: {
    code: 'AK',
    state: 'Alaska',
    imagePath: '/flags/wiki/AK.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Flag_of_Alaska.svg/1920px-Flag_of_Alaska.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Alaska.svg',
  },
  AL: {
    code: 'AL',
    state: 'Alabama',
    imagePath: '/flags/wiki/AL.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Alabama.svg/1920px-Flag_of_Alabama.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Alabama.svg',
  },
  AR: {
    code: 'AR',
    state: 'Arkansas',
    imagePath: '/flags/wiki/AR.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Flag_of_Arkansas.svg/1920px-Flag_of_Arkansas.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Arkansas.svg',
  },
  AZ: {
    code: 'AZ',
    state: 'Arizona',
    imagePath: '/flags/wiki/AZ.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Flag_of_Arizona.svg/1920px-Flag_of_Arizona.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Arizona.svg',
  },
  CA: {
    code: 'CA',
    state: 'California',
    imagePath: '/flags/wiki/CA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_California.svg/1920px-Flag_of_California.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_California.svg',
  },
  CO: {
    code: 'CO',
    state: 'Colorado',
    imagePath: '/flags/wiki/CO.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Flag_of_Colorado.svg/1920px-Flag_of_Colorado.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Colorado.svg',
  },
  CT: {
    code: 'CT',
    state: 'Connecticut',
    imagePath: '/flags/wiki/CT.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Flag_of_Connecticut.svg/1920px-Flag_of_Connecticut.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Connecticut.svg',
  },
  DE: {
    code: 'DE',
    state: 'Delaware',
    imagePath: '/flags/wiki/DE.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Flag_of_Delaware.svg/1920px-Flag_of_Delaware.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Delaware.svg',
  },
  FL: {
    code: 'FL',
    state: 'Florida',
    imagePath: '/flags/wiki/FL.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Flag_of_Florida.svg/1920px-Flag_of_Florida.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Florida.svg',
  },
  GA: {
    code: 'GA',
    state: 'Georgia',
    imagePath: '/flags/wiki/GA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Flag_of_the_State_of_Georgia.svg/1920px-Flag_of_the_State_of_Georgia.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_the_State_of_Georgia.svg',
  },
  HI: {
    code: 'HI',
    state: 'Hawaii',
    imagePath: '/flags/wiki/HI.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Flag_of_Hawaii.svg/1920px-Flag_of_Hawaii.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Hawaii.svg',
  },
  IA: {
    code: 'IA',
    state: 'Iowa',
    imagePath: '/flags/wiki/IA.png',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Flag_of_Iowa.svg/1920px-Flag_of_Iowa.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Iowa.svg',
  },
  ID: {
    code: 'ID',
    state: 'Idaho',
    imagePath: '/flags/wiki/ID.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_Idaho.svg/1920px-Flag_of_Idaho.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Idaho.svg',
  },
  IL: {
    code: 'IL',
    state: 'Illinois',
    imagePath: '/flags/wiki/IL.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Flag_of_Illinois.svg/1920px-Flag_of_Illinois.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Illinois.svg',
  },
  IN: {
    code: 'IN',
    state: 'Indiana',
    imagePath: '/flags/wiki/IN.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Flag_of_Indiana.svg/1920px-Flag_of_Indiana.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Indiana.svg',
  },
  KS: {
    code: 'KS',
    state: 'Kansas',
    imagePath: '/flags/wiki/KS.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Flag_of_Kansas.svg/1920px-Flag_of_Kansas.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Kansas.svg',
  },
  KY: {
    code: 'KY',
    state: 'Kentucky',
    imagePath: '/flags/wiki/KY.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Flag_of_Kentucky.svg/1920px-Flag_of_Kentucky.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Kentucky.svg',
  },
  LA: {
    code: 'LA',
    state: 'Louisiana',
    imagePath: '/flags/wiki/LA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Flag_of_Louisiana.svg/1920px-Flag_of_Louisiana.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Louisiana.svg',
  },
  MA: {
    code: 'MA',
    state: 'Massachusetts',
    imagePath: '/flags/wiki/MA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Flag_of_Massachusetts.svg/1920px-Flag_of_Massachusetts.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Massachusetts.svg',
  },
  MD: {
    code: 'MD',
    state: 'Maryland',
    imagePath: '/flags/wiki/MD.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Flag_of_Maryland.svg/1920px-Flag_of_Maryland.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Maryland.svg',
  },
  ME: {
    code: 'ME',
    state: 'Maine',
    imagePath: '/flags/wiki/ME.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Flag_of_Maine.svg/1920px-Flag_of_Maine.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Maine.svg',
  },
  MI: {
    code: 'MI',
    state: 'Michigan',
    imagePath: '/flags/wiki/MI.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Flag_of_Michigan.svg/1920px-Flag_of_Michigan.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Michigan.svg',
  },
  MN: {
    code: 'MN',
    state: 'Minnesota',
    imagePath: '/flags/wiki/MN.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Flag_of_Minnesota.svg/1920px-Flag_of_Minnesota.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Minnesota.svg',
  },
  MO: {
    code: 'MO',
    state: 'Missouri',
    imagePath: '/flags/wiki/MO.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Flag_of_Missouri.svg/1920px-Flag_of_Missouri.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Missouri.svg',
  },
  MS: {
    code: 'MS',
    state: 'Mississippi',
    imagePath: '/flags/wiki/MS.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Flag_of_Mississippi.svg/1920px-Flag_of_Mississippi.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Mississippi.svg',
  },
  MT: {
    code: 'MT',
    state: 'Montana',
    imagePath: '/flags/wiki/MT.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_Montana.svg/1920px-Flag_of_Montana.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Montana.svg',
  },
  NC: {
    code: 'NC',
    state: 'North Carolina',
    imagePath: '/flags/wiki/NC.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Flag_of_North_Carolina.svg/1920px-Flag_of_North_Carolina.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_North_Carolina.svg',
  },
  ND: {
    code: 'ND',
    state: 'North Dakota',
    imagePath: '/flags/wiki/ND.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Flag_of_North_Dakota.svg/1920px-Flag_of_North_Dakota.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_North_Dakota.svg',
  },
  NE: {
    code: 'NE',
    state: 'Nebraska',
    imagePath: '/flags/wiki/NE.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Flag_of_Nebraska.svg/1920px-Flag_of_Nebraska.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Nebraska.svg',
  },
  NH: {
    code: 'NH',
    state: 'New Hampshire',
    imagePath: '/flags/wiki/NH.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Flag_of_New_Hampshire.svg/1920px-Flag_of_New_Hampshire.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_New_Hampshire.svg',
  },
  NJ: {
    code: 'NJ',
    state: 'New Jersey',
    imagePath: '/flags/wiki/NJ.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Flag_of_New_Jersey.svg/1920px-Flag_of_New_Jersey.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_New_Jersey.svg',
  },
  NM: {
    code: 'NM',
    state: 'New Mexico',
    imagePath: '/flags/wiki/NM.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_New_Mexico.svg/1920px-Flag_of_New_Mexico.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_New_Mexico.svg',
  },
  NV: {
    code: 'NV',
    state: 'Nevada',
    imagePath: '/flags/wiki/NV.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Flag_of_Nevada.svg/1920px-Flag_of_Nevada.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Nevada.svg',
  },
  NY: {
    code: 'NY',
    state: 'New York',
    imagePath: '/flags/wiki/NY.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_New_York.svg/1920px-Flag_of_New_York.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_New_York.svg',
  },
  OH: {
    code: 'OH',
    state: 'Ohio',
    imagePath: '/flags/wiki/OH.png',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Flag_of_Ohio.svg/1920px-Flag_of_Ohio.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Ohio.svg',
  },
  OK: {
    code: 'OK',
    state: 'Oklahoma',
    imagePath: '/flags/wiki/OK.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Flag_of_Oklahoma.svg/1920px-Flag_of_Oklahoma.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Oklahoma.svg',
  },
  OR: {
    code: 'OR',
    state: 'Oregon',
    imagePath: '/flags/wiki/OR.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Flag_of_Oregon.svg/1920px-Flag_of_Oregon.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Oregon.svg',
  },
  PA: {
    code: 'PA',
    state: 'Pennsylvania',
    imagePath: '/flags/wiki/PA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Flag_of_Pennsylvania.svg/1920px-Flag_of_Pennsylvania.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Pennsylvania.svg',
  },
  RI: {
    code: 'RI',
    state: 'Rhode Island',
    imagePath: '/flags/wiki/RI.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Flag_of_Rhode_Island.svg/1920px-Flag_of_Rhode_Island.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Rhode_Island.svg',
  },
  SC: {
    code: 'SC',
    state: 'South Carolina',
    imagePath: '/flags/wiki/SC.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Flag_of_South_Carolina.svg/1920px-Flag_of_South_Carolina.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_South_Carolina.svg',
  },
  SD: {
    code: 'SD',
    state: 'South Dakota',
    imagePath: '/flags/wiki/SD.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_South_Dakota.svg/1920px-Flag_of_South_Dakota.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_South_Dakota.svg',
  },
  TN: {
    code: 'TN',
    state: 'Tennessee',
    imagePath: '/flags/wiki/TN.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Flag_of_Tennessee.svg/1920px-Flag_of_Tennessee.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Tennessee.svg',
  },
  TX: {
    code: 'TX',
    state: 'Texas',
    imagePath: '/flags/wiki/TX.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Flag_of_Texas.svg/1920px-Flag_of_Texas.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Texas.svg',
  },
  UT: {
    code: 'UT',
    state: 'Utah',
    imagePath: '/flags/wiki/UT.png',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Flag_of_Utah.svg/1920px-Flag_of_Utah.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Utah.svg',
  },
  VA: {
    code: 'VA',
    state: 'Virginia',
    imagePath: '/flags/wiki/VA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Flag_of_Virginia.svg/1920px-Flag_of_Virginia.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Virginia.svg',
  },
  VT: {
    code: 'VT',
    state: 'Vermont',
    imagePath: '/flags/wiki/VT.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Vermont.svg/1920px-Flag_of_Vermont.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Vermont.svg',
  },
  WA: {
    code: 'WA',
    state: 'Washington',
    imagePath: '/flags/wiki/WA.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Flag_of_Washington.svg/1920px-Flag_of_Washington.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Washington.svg',
  },
  WI: {
    code: 'WI',
    state: 'Wisconsin',
    imagePath: '/flags/wiki/WI.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Flag_of_Wisconsin.svg/1920px-Flag_of_Wisconsin.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Wisconsin.svg',
  },
  WV: {
    code: 'WV',
    state: 'West Virginia',
    imagePath: '/flags/wiki/WV.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Flag_of_West_Virginia.svg/1920px-Flag_of_West_Virginia.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_West_Virginia.svg',
  },
  WY: {
    code: 'WY',
    state: 'Wyoming',
    imagePath: '/flags/wiki/WY.png',
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Flag_of_Wyoming.svg/1920px-Flag_of_Wyoming.svg.png',
    sourcePageUrl: 'https://commons.wikimedia.org/wiki/File:Flag_of_Wyoming.svg',
  },
};
